import {AxiosInstance} from "axios";
import Payment from "../model/payment/Payment";
import PaymentRecommendation from "../model/payment/PaymentRecommendation";

/**
 * Invoice payment Api.
 */
export default class InvoicePaymentApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	fetchInvoicePayments(invoiceId: string): Promise<Array<Payment>> {
		const url = `/api/web/accounting/invoices/${invoiceId}/payments`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(Payment.fromJson));
	}

	createInvoicePayment(invoiceId: string, data: Payment): Promise<Payment> {
		const url = `/api/web/accounting/invoices/${invoiceId}/payments`;
		return this.axiosInstance.post(url, data.toJson()).then(resp => Payment.fromJson(resp.data));
	}

	fetchInvoicePaymentRecommendations(invoiceId: string): Promise<PaymentRecommendation[]> {
		const url = `/api/web/accounting/invoices/${invoiceId}/payment_recommendations`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(PaymentRecommendation.fromJson))
	}

	/**
	 * Confirm payment recommendation.
	 * @param {string} paymentRecommendationId
	 * @returns {Promise<any>}
	 */
	confirmInvoicePaymentRecommendation(paymentRecommendationId: string): Promise<any> {
		const url = `/api/web/accounting/payment_recommendations/${paymentRecommendationId}/confirm`;
		return this.axiosInstance.put(url);
	}

	/**
	 * Reject payment recommendation.
	 * @param {string} paymentRecommendationId
	 * @returns {AxiosPromise<any>}
	 */
	rejectInvoicePaymentRecommendation(paymentRecommendationId: string): Promise<any> {
		const url = `/api/web/accounting/payment_recommendations/${paymentRecommendationId}/reject`;
		return this.axiosInstance.put(url);
	}
}
